export class AppStatus {
  static inactive = 0;
  static inProgress = 1;
  static active = 2;
  static noResults = 3;
}
